import styled, { css } from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStatusPill } from 'types/ui/statusPill.interface'

export const WaterfallWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const WaterfallRow = styled.div<{ $clickable?: boolean }>`
  display: grid;
  grid-template-columns: minmax(0, 17rem) minmax(0, 1fr) 6.5rem;
  column-gap: 1rem;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border: 1px solid transparent;
  border-radius: ${tokens.radius.control};
  transition: background ${tokens.motion.duration} ${tokens.motion.ease},
    border-color ${tokens.motion.duration} ${tokens.motion.ease};
  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
      &:hover {
        background: ${tokens.surface.glass};
        border-color: ${tokens.border.strong};
      }
    `}
`

export const LabelCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const BucketTag = styled.span`
  width: fit-content;
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
  cursor: help;
  border-bottom: 1px dotted ${tokens.border.strong};
`

export const Track = styled.div`
  position: relative;
  height: 2rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  background-image: linear-gradient(to right, ${tokens.border.hairline} 1px, transparent 1px);
  background-size: calc(100% / 4) 100%;
`

export const Segment = styled.div<{
  $left: number
  $width: number
  $tone: IStatusPill['status']
  $inset?: boolean
}>`
  position: absolute;
  top: 0.25rem;
  bottom: 0.25rem;
  left: ${({ $left }) => $left}%;
  width: ${({ $width }) => $width}%;
  min-width: 0.25rem;
  border-radius: ${tokens.radius.chip};
  background: ${({ $tone, $inset }) => ($inset ? tokens.surface.inset : tokens.status[$tone].bg)};
  border: 1px solid ${({ $tone, $inset }) => ($inset ? tokens.border.hairline : tokens.status[$tone].fg)};
  cursor: ${({ $inset }) => ($inset ? 'help' : 'inherit')};
  transition: transform ${tokens.motion.duration} ${tokens.motion.ease};

  ${WaterfallRow}:hover & {
    transform: scaleY(1.08);
  }
`

export const ValueCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  min-width: 0;
`

export const ValueText = styled.span<{ $tone: IStatusPill['status']; $muted?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: ${({ $tone, $muted }) => ($muted ? tokens.text.muted : tokens.status[$tone].fg)};
`

export const OpenHint = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  white-space: nowrap;
  color: ${tokens.text.muted};
  transition: color ${tokens.motion.duration} ${tokens.motion.ease};

  ${WaterfallRow}:hover & {
    color: ${tokens.accent.base};
  }
`
